import axios from './axios';

export async function getCredits() {
  const response = await axios.get('/credits');
  return response.data;
}

export async function getCreditPackages() {
  const response = await axios.get('/credits/packages');
  return response.data;
}

export async function checkAiAvailability() {
  const response = await axios.get('/ai/check-availability');
  return response.data;
}

export async function processImageWithAi(imageBase64, zoneId, projectId, zoneTitle, elementIds) {
  const response = await axios.post('/ai/process-image', 
    { imageBase64, zoneId, projectId, zoneTitle, elementIds: elementIds || [] },
    { timeout: 120000 }
  );
  return response.data;
}

export async function getAiJobs() {
  const response = await axios.get('/ai/jobs');
  return response.data;
}

export async function getAiJobStatus(jobId) {
  const response = await axios.get(`/ai/jobs/${jobId}`);
  return response.data;
}

export async function deleteAiJob(jobId) {
  const response = await axios.delete(`/ai/jobs/${jobId}`);
  return response.data;
}
